export default __webpack_public_path__ + "static/media/cursos_graduacao_unb.68230318.csv";